import * as Sentry from '@sentry/react';
import { applyMiddleware, compose, createStore, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { appEnv } from '../../_env';
import { rootReducer } from './rootReducer';
import { rootSaga } from './rootSaga';

export { useTypedSelector, type RootStateT } from './hooks';

declare global {
   interface Window {
      __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
   }
}

export function initStore(): Store {
   const sagaMiddleware = createSagaMiddleware();
   const sentryEnhancer = Sentry.createReduxEnhancer({});
   const composeEnhancers = appEnv.isProd ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
   const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware), sentryEnhancer));

   // run root saga
   sagaMiddleware.run(rootSaga);

   return store;
}
